import { memo } from 'react'
import { textFormatPresets } from '@finanzcheck/catalyst-renderless-components'
import { observer } from 'mobx-react'

import ConditionalField from 'components/ConditionalField'
import PathGenderSelect from 'components/PathGenderSelect'
import PathInput from 'components/PathInput'
import PathPhoneInput from 'components/PathPhoneInput'
import PathYesNo from 'components/PathYesNo'
import PathDateInput from 'components/PathDateInput'

import { AutoFillType } from 'utils/autofill'
import { Typography } from '@material-ui/core'

import ConditionalWrapper from 'components/ConditionalWrapper'
import TonlineEmailInfoBox from 'components/Banner/TonlineEmailInfoBox'
import { Debtor } from '../PersonalFormPrimary/PersonalForm.interface'

interface Props {
  debtor: Debtor
  dependson?: string
}

const PersonalForm = observer(
  ({ debtor = Debtor.SECONDARY, dependson }: Props) => {
    const isSecondary = debtor === Debtor.SECONDARY

    return (
      <ConditionalWrapper dependson={dependson}>
        <ConditionalField path={`debtors.${debtor}`}>
          <Typography variant="h4">Persönliche Angaben</Typography>

          <PathGenderSelect path={`debtors.${debtor}.personal.gender`} />

          <PathInput
            path={`debtors.${debtor}.personal.firstname`}
            autoComplete={AutoFillType.OFF}
            acceptedInput={/\D/}
            formatters={textFormatPresets.name}
          />
          <PathInput
            path={`debtors.${debtor}.personal.lastname`}
            autoComplete={AutoFillType.OFF}
            acceptedInput={/\D/}
          />
          <PathDateInput
            path={`debtors.${debtor}.personal.birthday`}
            autoComplete={AutoFillType.OFF}
          />
          <PathYesNo path="debtors.isSameContactInformation" />

          <PathPhoneInput
            path={`debtors.${debtor}.contact.phoneNumber`}
            autoComplete={AutoFillType.DISABLED_HARD}
            tooltip="Die Telefonnummer wird für eventuelle Rückfragen benötigt."
          />
          <PathInput
            path={`debtors.${debtor}.contact.email`}
            type="email"
            autoComplete={AutoFillType.DISABLED_HARD}
          />
          <TonlineEmailInfoBox isSecondary={isSecondary} />
        </ConditionalField>
      </ConditionalWrapper>
    )
  }
)

export default memo(PersonalForm)
